import withSchema from 'ia-react-core/~/hocs/schema/withSchema';

import withUniqueId from '../../../hocs/helpers/_withUniqueId';
import compose from '../../../utils/components/_compose';

import CreateForm, { CreateFormProps } from './CreateForm';

const ComposedForm: (<Values, Data, Error = {}>(
  props: CreateFormProps<Values, Data, Error>
) => React.ReactElement<CreateFormProps<Values, Data, Error>>) & {
  displayName: typeof CreateForm.displayName;
} = compose<any>(
  withUniqueId('formId', { acceptOverride: true }),
  withSchema('form'),
)(CreateForm);

ComposedForm.displayName = CreateForm.displayName;

export * from './CreateForm';
export default ComposedForm;
